const aggregate = (data, selector, reducer, initial) => {
    let result = initial;
    for (const iterator of data) {
        const mappedValue = selector(iterator);
        result = reducer(result, mappedValue);
    }
    return result;
};
function reduceToArray(data, map, allowUndefinedOrNull = false) {
    return aggregate(data, map, (acc, value) => {
        return !allowUndefinedOrNull && (value === null || value === undefined) ? acc : acc.concat(value);
    }, []);
}
export { reduceToArray };
